"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var comment_1 = __importDefault(require("./sub/comment"));
var link_1 = __importDefault(require("./sub/link"));
var background_media_1 = __importDefault(require("./sub/background-media"));
var logo_1 = __importDefault(require("./sub/logo"));
var title_1 = __importDefault(require("./sub/title"));
var advertising_1 = __importDefault(require("./sub/advertising"));
var aspect_ratio_1 = __importDefault(require("./sub/aspect-ratio"));
var ContentPlusC = function (_a) {
    var adObj = _a.adObj, native = _a.adObj.native, _b = _a.marking, marking = _b === void 0 ? 'partner' : _b, mobile = _a.mobile, white = _a.white;
    return (React.createElement(link_1.default, { adObj: adObj, className: "mod flex", style: {
            height: '100%',
        } },
        React.createElement(aspect_ratio_1.default, { ratio: '72%' },
            React.createElement("div", { style: {
                    display: 'flex',
                    flexDirection: 'column',
                    height: '100%',
                    borderRadius: '8px',
                    overflow: 'hidden',
                    backgroundColor: '#f6f8fb',
                } },
                React.createElement(comment_1.default, { placement: "content-plus-c", adObj: adObj }),
                React.createElement("div", { style: {
                        display: 'flex',
                        flex: '1 1 auto',
                    } },
                    React.createElement(background_media_1.default, { native: native, style: {
                            flex: '1',
                            backgroundSize: 'cover',
                            backgroundPosition: 'center',
                        } }),
                    React.createElement(advertising_1.default, { adObj: adObj, marking: marking, style: {
                            borderTopRightRadius: '8px',
                            borderBottomLeftRadius: '8px',
                            height: '30px',
                            backgroundColor: white
                                ? 'rgba(71, 68, 69, 0.8)'
                                : 'rgba(248, 248, 248, 0.8)',
                            position: 'absolute',
                            right: '0',
                            top: '0',
                            paddingTop: '4px',
                            paddingRight: '27px',
                            paddingLeft: '11px',
                        }, top: '2px', uppercase: true, white: white })),
                React.createElement("div", { style: {
                        flex: '0 0 auto',
                        margin: '16px',
                        overflow: 'hidden',
                        position: 'relative',
                        display: 'flex',
                        flexDirection: 'row',
                        justifyContent: 'space-between',
                    } },
                    React.createElement(title_1.default, { h: 3, native: native, id: "native-add__title", style: {
                            fontSize: mobile ? '22px' : '28px',
                            fontWeight: 300,
                            fontStyle: 'normal',
                            fontStretch: 'normal',
                            lineHeight: '1.21',
                            letterSpacing: 'normal',
                            color: '#474445',
                            margin: '0px',
                            paddingTop: '0px',
                            float: 'left',
                            hyphens: 'none',
                            msHyphens: 'none',
                            WebkitHyphens: 'none',
                            flex: '0 1 auto',
                            alignSelf: 'center',
                        } }),
                    React.createElement(logo_1.default, { native: native, style: {
                            height: 'auto',
                            flex: '0 1 auto',
                            maxHeight: '70px',
                            maxWidth: '20%',
                            alignSelf: 'flex-end',
                        } }))))));
};
exports.default = ContentPlusC;
